import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { InventoryServices } from "../services/InventoryServices";
import { FaArrowDown } from "react-icons/fa";
import ProductOptions from "../components/ProductOptions";
import VerifiedNavigation from "../../navigation/components/VerifiedNavigation";

const ViewCollection = () => {
  const { title } = useParams();
  const [collection, setCollection] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);

  const handleClick = (productId) => {
    setItemToRemove(productId);
    setShowOptions(true);
  };

  const handleDeleteItem = async () => {
    if (!itemToRemove) return;
    const response = await InventoryServices.deleteItem(itemToRemove);
    if (!response.success) {
      console.log("There was an error", response);
      return;
    }
    setShowOptions(false);
  };

  const fetchCollectionByTitle = async () => {
    const response = await InventoryServices.fetchCollectionByTitle(title);
    setCollection(response.data[0]?.products || []);
  };

  useEffect(() => {
    fetchCollectionByTitle();
  }, []);

  return (
    <div className="collection-view">
      <VerifiedNavigation />
      <div className="item collection-item">
        <h1 style={{ textAlign: "center", paddingBottom: "10px" }}>{title}</h1>

        {collection && collection.length > 0 ? (
          collection.map((item, index) => (
            <div key={index} style={{ display: "flex", width: "100vw" }}>
              <Link
                to={`/manager/inventory/${item?._id}`}
                className={`inventory-products ${
                  index % 2 === 0 ? "even" : "odd"
                }`}
              >
                <div className="inventory-products-left">
                  <img src={item.images} alt={item.metadata} />
                  <div className="inner-flex">
                    <p>{item.name}</p>
                    <span>{item.category}</span>
                  </div>
                  <p>${item.price}</p>
                </div>

                <div className="inventory-products-right">
                  <p>
                    {item.stockStatus} <FaArrowDown />
                  </p>
                </div>
              </Link>

              <div className="three-dots" onClick={() => handleClick(item._id)}>
                <p>.</p>
                <p>.</p>
                <p>.</p>
              </div>
            </div>
          ))
        ) : (
          <p className="no-products">Your {title} Products Will Show Up Here</p>
        )}
      </div>

      {showOptions && (
        <ProductOptions
          isOpen={showOptions}
          onClose={() => setShowOptions(false)}
          handleDeleteItem={handleDeleteItem}
        />
      )}
    </div>
  );
};

export default ViewCollection;
